var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('article',{staticClass:"container"},[_c('h3',[_vm._v("لطفا منتظر بمانید ...")])])
}]

export { render, staticRenderFns }